import React, { Component } from "react";
import "./LayerRevealMobile.css";
import layerOne from "../../assets/AboutUs/layersMobile/1.png";
import layerTwo from "../../assets/AboutUs/layersMobile/2.png";
import layerThree from "../../assets/AboutUs/layersMobile/3.png";
import layerFour from "../../assets/AboutUs/layersMobile/4.png";
import { Controller, Scene } from "react-scrollmagic";
import { Tween, Timeline } from "react-gsap";

class LayerRevealMobile extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <div id="trigger" />
        <Controller>
          <Scene triggerElement="#trigger" duration={600}>
            {(progress) => (
              <div className="row justify-content-center position-relative layer-mobile-reveal">
                <Tween
                  from={{
                    y: 143,
                  }}
                  totalProgress={progress}
                  paused
                >
                  <img
                    src={layerFour}
                    className="position-absolute layer-mobile-four"
                  />
                </Tween>
                <Tween
                  from={{
                    y: 143,
                  }}
                  totalProgress={progress}
                  paused
                >
                  <img
                    src={layerThree}
                    className="position-absolute layer-mobile-three"
                  />
                </Tween>
                <Tween
                  from={{
                    y: 143,
                  }}
                  totalProgress={progress}
                  paused
                >
                  <img
                    src={layerTwo}
                    className="position-absolute layer-mobile-two"
                  />
                </Tween>
                <Tween
                  from={{
                    y: 143,
                  }}
                  totalProgress={progress}
                  paused
                >
                  <img
                    src={layerOne}
                    className="position-absolute layer-mobile-one"
                  />
                </Tween>
              </div>
            )}
          </Scene>
        </Controller>
      </div>
    );
  }
}

export default LayerRevealMobile;
